import { boxShadowIndentDesktop } from 'components/page/ContactList/Item/ContactItemView.styled'

export const deleteContactListParameters = 'contactSelectedIds'
export const NUMBER_DEFAULT_LIMIT_FOR_LOAD_CONTACT = 30
export const CONTACT_TYPE_USER = 1
export const contactItemHeightMargin = 10
export const contactListPromoMargin = `${contactItemHeightMargin}px ${boxShadowIndentDesktop}px`
export const contactListPromoPadding = contactListPromoMargin
